import { QueryClient, useQuery } from "@tanstack/react-query";
import { GeneratedText } from "./types/GeneratedTexts";

export const REEPRISE_DETAILS_QUERY_KEY = "reeprise-details-query";

export function getGeneratedTextDetailsQueryKey(generatedTextId?: number) {
  return [REEPRISE_DETAILS_QUERY_KEY, `${generatedTextId ?? "pending"}`] as const;
}

export function invalidateQuery(client: QueryClient, textId?: number): void {
  client.invalidateQueries({ queryKey: getGeneratedTextDetailsQueryKey(textId) });
}

export function primeGeneratedTextDetailsQuery(
  client: QueryClient,
  text: GeneratedText,
): void {
  client.setQueryData(getGeneratedTextDetailsQueryKey(text.id), text);
}

export function useGeneratedTextDetails(generated_text_id?: number) {
  const reepriseDetailsQuery = useQuery({
    queryKey: getGeneratedTextDetailsQueryKey(generated_text_id),
    enabled: typeof generated_text_id === "number",
    refetchInterval: (query) => {
      if (query.state.data && query.state.data.status === "PENDING") {
        return 500;
      }
      return false;
    },
    queryFn: async () => {
      if (typeof generated_text_id !== "number") {
        throw new Error("generated_text_id is required");
      }
      const res = await fetch(
        `/api/reeprise/generated_texts/${generated_text_id}/`,
      );
      if (!res.ok) {
        throw new Error(
          `could not fetch /api/reeprise/generated_texts/${generated_text_id}`,
        );
      }
      return (await res.json()) as GeneratedText;
    },
  });

  return reepriseDetailsQuery;
}
